import { useLocation, useNavigate } from "react-router-dom";
import WithTableView from "../../components/withTableView/withTableView";
import Pagination from "../../components/pagination/pagination";

const Applicants = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <WithTableView
      heading="Applicants"
      head={[{ title: "S.No." }, { title: "Title" }, { title: "" }]}
      body_keys={[]}
      body={[]}
      show_btn_1={false}
      isIcon={true}
      iconType="add"
      onRowClick={() => {}}
      loading={false}
      customElement={<></>}
    />
  );
};

export default Applicants;
